import { AxiosResponse, AxiosError } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TUnsogyomuHatyusyoGetReq,
  TUnsogyomuHatyusyoGetRes,
} from "./TUnsogyomuHatyusyo"
import { TUnsogyomuHatyusyoPrintReq } from "../../../service/order/unsogyomuHatyusyo/TUnsogyomuHatyusyo"
import { T検索日種別コード } from "../../../constant/enum/frontend"

/**
 * 品名マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class UnsogyomuHatyusyoService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof MenuService
   */
  getList = async (params: TUnsogyomuHatyusyoGetReq<T検索日種別コード>) => {
    try {
      const innerParams = { ...params }
      if (innerParams.傭車会社あり対象フラグ == null) {
        innerParams.傭車会社あり対象フラグ = 1
      }
      //傭車ありのみ表示する
      const res: AxiosResponse<TApiResponse<TUnsogyomuHatyusyoGetRes>> =
        await this.postInner(`/order/zyutyuhaisya/actions/getlist`, innerParams)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 運送業務発注書印刷
   *
   * @param {TUnsogyomuHatyusyoPrintReq} params
   * @memberof UnsogyomuHatyusyoService
   */
  printUnsogyomuHatyusyoPrint = async (
    params: TUnsogyomuHatyusyoPrintReq,
    resolve?: (param: TApiResponse<TUnsogyomuHatyusyoPrintReq[]>) => any,
    reject?: (param: AxiosError<TUnsogyomuHatyusyoPrintReq[]>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G040802`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
